import { render } from "./PortalBoardMeetings.vue?vue&type=template&id=6bc9c9da"
import script from "./PortalBoardMeetings.vue?vue&type=script&lang=js"
export * from "./PortalBoardMeetings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__